(function () {
  'use strict';
  const keys = ['width', 'height', 'diameter'];
  const extraKeys = ['runflat', 'extra_load', 'three_peak_snowflake', 'rim_protection'];
  let catalogPromise;
  const refreshFrames = new WeakMap();
  const field = (form, key) => form.querySelector(`[data-tyre-filter-key="${key}"]`);
  const clean = (v) => String(v || '').replace(/\.0+$/, '');
  const tagPart = (v) => clean(v).toLowerCase().replace(/\./g, 'p').replace(/[^a-z0-9]/g, '');
  const sizeTag = (w, h, d) => `tyresize${tagPart(w)}x${tagPart(h)}r${tagPart(d)}`;
  const vehicle = (form) => form.querySelector('.vehicle-tabs input:checked')?.value || 'auto';
  const seasonField = (form) => form.querySelector('.season-tabs input:checked') || field(form, 'season');
  function loadCatalog(form) {
    if (!catalogPromise) catalogPromise = fetch(form.dataset.catalogIndex).then(r => {
      if (!r.ok) throw new Error('catalog');
      return r.json();
    }).then(data => ({...data, rows: data.rows.map(r => [...data.dimensions[r[0]], data.seasons[r[1]], ...r.slice(2)])})).catch(error => {catalogPromise = null; throw error;});
    return catalogPromise;
  }
  function syncIllustration(form) {
    form.dataset.vehicle = vehicle(form);
    form.dataset.season = seasonField(form)?.value || 'summer';
    if (!form.dataset.activeDimension) form.dataset.activeDimension = 'width';
    const defaults = vehicle(form) === 'moto' ? ['90', '90', '21'] : vehicle(form) === 'truck' ? ['215', '65', '16'] : ['205', '55', '16'];
    keys.forEach((key,i) => {
      const node = form.querySelector(`[data-size-part="${key}"]`);
      const sidewall = form.querySelector(`[data-sidewall-size="${key}"]`);
      if (sidewall) sidewall.textContent = clean(field(form,key)?.value) || defaults[i];
      if (!node) return;
      const value = clean(field(form,key)?.value) || defaults[i];
      if (node.textContent !== value) {
        node.textContent = value;
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) node.animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:220});
      }
      node.classList.toggle('is-selected', Boolean(field(form,key)?.value));
    });
  }
  function syncState(form) {
    const busy = form.getAttribute('aria-busy') === 'true';
    keys.forEach((key,i) => {field(form,key).disabled = busy || keys.slice(0,i).some(k => !field(form,k).value);});
    form.querySelector('[data-tyre-search-submit]').disabled = busy || keys.some(k => !field(form,k).value) || (form._catalogRows && !form._catalogRows.length);
    syncIllustration(form);
  }
  function replaceOptions(form,key,rows,column) {
    const select=field(form,key), selected=select.value;
    const counts=new Map(); rows.forEach(r => counts.set(r[column],(counts.get(r[column])||0)+r[7]));
    const opts=[new Option('Scegli','')];
    [...counts.keys()].sort((a,b)=>Number.isFinite(Number(a))&&Number.isFinite(Number(b))?Number(a)-Number(b):a.localeCompare(b,'it',{numeric:true})).forEach(v=> {
      const label=key==='height' && v==='0' ? 'Non indicata' : key==='diameter' ? Number(v)<40?`${v}″`:`${v} (speciale)` : v;
      opts.push(new Option(label,v));
    });
    select.replaceChildren(...opts);select.value=counts.has(selected)?selected:'';
  }
  function refresh(form,data) {
    let rows=data.rows.filter(r=>r[0]===vehicle(form));
    // Dimensions depend only on preceding dimensions: changing the vehicle cannot leave stale options.
    keys.forEach((key,i)=> {replaceOptions(form,key,rows,i+1);const v=field(form,key).value;if(v)rows=rows.filter(r=>r[i+1]===v);});
    const seasons=new Set(rows.map(r=>r[4]));
    form.querySelectorAll('.season-tabs input').forEach(r=> {r.disabled=Boolean(r.value && !seasons.has(r.value));if(r.checked && r.disabled)form.querySelector('.season-tabs input[value=""]').checked=true;});
    const select=field(form,'season');
    if(select){[...select.options].forEach(o=>o.disabled=Boolean(o.value&&!seasons.has(o.value)));if(select.selectedOptions[0]?.disabled)select.value='';}
    const season=seasonField(form)?.value;if(season)rows=rows.filter(r=>r[4]===season);
    const extras=[...form.querySelectorAll('.tyre-extra-opt input')];
    extras.forEach(cb=> {const bit=1<<extraKeys.indexOf(cb.name.split('.').pop());cb.disabled=!rows.some(r=>r[6]&bit);if(cb.disabled)cb.checked=false;});
    const flags=extras.filter(cb=>cb.checked).reduce((n,cb)=>n|(1<<extraKeys.indexOf(cb.name.split('.').pop())),0);
    rows=rows.filter(r=>(r[6]&flags)===flags);
    const brands=new Set(rows.map(r=>data.brands[r[5]][0]));
    form.querySelectorAll('input[name="brand"]').forEach(cb=>{cb.disabled=!brands.has(cb.value);if(cb.disabled)cb.checked=false;cb.closest('[data-brand-picker-item]').dataset.unavailable=String(cb.disabled);});
    form.querySelector('[data-brand-picker]')?.dispatchEvent(new CustomEvent('catalog:brands-updated'));
    const chosen=[...form.querySelectorAll('input[name="brand"]:checked')].map(cb=>cb.value);
    if(chosen.length)rows=rows.filter(r=>chosen.includes(data.brands[r[5]][0]));
    form._catalogRows=rows;
    const status=form.querySelector('[data-catalog-status]');
    if(status)status.textContent=rows.length ? `${rows.reduce((n,r)=>n+r[7],0).toLocaleString('it-IT')} pneumatici nel catalogo · disponibilità verificata nei risultati` : 'Nessuna combinazione disponibile. Prova un altro veicolo o misura.';
    syncState(form);
  }
  function prefill(form) {
    const params=new URLSearchParams(location.search), filters=window.gommaDOT?.filters||{};
    const tag=(params.get('q')||'').match(/tag:tyresize([a-z0-9]+)x([a-z0-9]+)r([a-z0-9]+)/i);
    const vehicleTag=(params.get('q')||'').match(/tag:(auto|moto|truck)\b/);
    const v=params.get('vehicle')||params.get(filters.vehicle)||vehicleTag?.[1]||form.dataset.initialVehicle;
    form.querySelectorAll('.vehicle-tabs input').forEach(cb=>{if(v)cb.checked=cb.value===v;});
    keys.forEach((key,i)=>{const val=clean(params.get(filters[key])||tag?.[i+1]?.replace(/p/g,'.'));if(val){field(form,key).add(new Option(val,val));field(form,key).value=val;}});
    const seasonTag=(params.get('q')||'').match(/tag:(summer|winter|all-season)\b/);
    const s=params.get('season')||params.get(filters.season)||seasonTag?.[1]||form.dataset.initialSeason;
    if(s){form.querySelectorAll('.season-tabs input').forEach(cb=>cb.checked=cb.value===s);if(field(form,'season'))field(form,'season').value=s;}
    const selectedBrands=params.has('filter.p.vendor') ? params.getAll('filter.p.vendor') : [form.dataset.initialBrand].filter(Boolean);
    form.querySelectorAll('input[name="brand"]').forEach(cb=>cb.checked=selectedBrands.includes(cb.value));
    form.querySelectorAll('.tyre-extra-opt input').forEach(cb=>cb.checked=['1','true'].includes(params.get(cb.name)));
  }
  function searchUrl(w,h,d,v,mask=7) {
    const config=window.gommaDOT;
    const url=new URL(config.routes.search,location.origin);
    // Indivisible size tag is generated from supplier dimensions, never the product title.
    // It narrows Shopify's result set before native metafield facets are evaluated.
    url.searchParams.set('q',`tag:${sizeTag(w,h,d)}${v?' AND tag:'+v:''}`);
    url.searchParams.set('type','product');url.searchParams.set('options[unavailable_products]','hide');url.searchParams.set('options[prefix]','none');
    [w,h,d].forEach((value,i)=>{if(mask&(1<<i))url.searchParams.set(config.filters[keys[i]],i===0?String(Number(value)):String(Number(value)).includes('.')?String(Number(value)):`${Number(value)}.0`);});
    return url;
  }
  function brandSearchUrl(form) {
    const current = new URL(location.href);
    const url = current.pathname === window.gommaDOT.routes.search
      ? current
      : new URL(window.gommaDOT.routes.search, location.origin);
    if (!url.searchParams.get('q')) url.searchParams.set('q', `tag:${vehicle(form)}`);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'hide');
    url.searchParams.set('options[prefix]', url.searchParams.get('q').includes('tag:') ? 'none' : 'last');
    url.searchParams.delete('filter.p.vendor');
    form.querySelectorAll('input[name="brand"]:checked:not(:disabled)').forEach((cb) => url.searchParams.append('filter.p.vendor', cb.value));
    return url;
  }
  window.GommaDotTyreSearch={searchUrl};
  function syncAdvancedOptions(form, open) {
    const panel = form.querySelector('[data-tyre-advanced-options]');
    const toggle = form.querySelector('[data-tyre-options-toggle]');
    if (!panel || !toggle) return;
    const expanded = Boolean(open);
    panel.hidden = !expanded;
    toggle.setAttribute('aria-expanded', String(expanded));
    const label = toggle.querySelector('[data-tyre-options-toggle-label]');
    if (label) label.textContent = expanded ? 'Meno opzioni' : 'Più opzioni';
    const icon = toggle.querySelector('.tyre-extra-opts__more-icon .icon');
    if (icon) icon.style.transform = expanded ? 'rotate(45deg)' : '';
  }

  function initAdvancedOptions(form) {
    const toggle = form.querySelector('[data-tyre-options-toggle]');
    const panel = form.querySelector('[data-tyre-advanced-options]');
    if (!toggle || !panel || toggle.dataset.initialized) return;
    toggle.dataset.initialized = 'true';
    toggle.addEventListener('click', () => {
      syncAdvancedOptions(form, panel.hidden);
      if (!panel.hidden) {
        window.requestAnimationFrame(() => {
          const firstControl = panel.querySelector('button, input, select');
          if (firstControl) firstControl.focus({ preventScroll: true });
        });
      }
    });
    syncAdvancedOptions(form, false);
  }


  async function initForm(form) {
    if(form.dataset.tyreSearchInitialized)return;
    form.dataset.tyreSearchInitialized='true';prefill(form);initAdvancedOptions(form);form.setAttribute('aria-busy','true');syncState(form);
    try{const data=await loadCatalog(form);form._catalog=data;form.removeAttribute('aria-busy');refresh(form,data);}
    catch(error){form.removeAttribute('aria-busy');syncState(form);form.querySelector('[data-catalog-status]').textContent='Disponibilità non caricata. Puoi cercare con i valori selezionati oppure ricaricare la pagina.';}
  }
  document.addEventListener('focusin',event=>{const form=event.target.closest('[data-tyre-search-form]');const key=event.target.dataset.tyreFilterKey;if(form&&keys.includes(key)){form.dataset.activeDimension=key;syncIllustration(form);}});
  function scheduleRefresh(form, changedKey) {
    if (!form?._catalog) return;
    if (changedKey && keys.includes(changedKey)) {
      form.dataset.activeDimension = changedKey;
      const index = keys.indexOf(changedKey);
      keys.slice(index + 1).forEach((key) => { field(form, key).value = ''; });
    }
    if (refreshFrames.has(form)) cancelAnimationFrame(refreshFrames.get(form));
    refreshFrames.set(form, requestAnimationFrame(() => {
      refreshFrames.delete(form);
      refresh(form, form._catalog);
    }));
  }
  document.addEventListener('input',event=>{const form=event.target.closest('[data-tyre-search-form]');const key=event.target.dataset.tyreFilterKey;if(form&&keys.includes(key))scheduleRefresh(form,key);});
  document.addEventListener('change',event=>{const form=event.target.closest('[data-tyre-search-form]');if(form)scheduleRefresh(form,event.target.dataset.tyreFilterKey);});
  document.addEventListener('brand-picker:apply', event => {
    const form = event.target.closest('[data-tyre-search-form]');
    if (!form || form.hasAttribute('aria-busy')) return;
    if (keys.every((key) => field(form, key).value)) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      return;
    }
    location.assign(brandSearchUrl(form).toString());
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-tyre-search-form]');if(!form)return;
    event.preventDefault();if(form.hasAttribute('aria-busy')||keys.some(k=>!field(form,k).value))return;
    const mask=(form._catalogRows||[]).reduce((m,r)=>m&r[8],7);
    const url=searchUrl(...keys.map(k=>field(form,k).value),vehicle(form),mask);
    const s=seasonField(form)?.value;if(s)url.searchParams.set(window.gommaDOT.filters.season,s);
    form.querySelectorAll('input[name="brand"]:checked:not(:disabled)').forEach(cb=>url.searchParams.append('filter.p.vendor',cb.value));
    form.querySelectorAll('.tyre-extra-opt input:checked:not(:disabled)').forEach(cb=>url.searchParams.append(cb.name,cb.value));
    location.assign(url.toString());
  });
  // Repair old dimension URLs without defaulting an unspecified vehicle to auto or losing filter parameters.
  const current=new URL(location.href), f=window.gommaDOT?.filters;
  if(f && current.pathname===window.gommaDOT.routes.search && !current.searchParams.get('q')?.includes('tag:tyresize')) {
    const size=keys.map(k=>current.searchParams.get(f[k]));
    if(size.every(Boolean)){
      const next=searchUrl(...size,current.searchParams.get(f.vehicle)||'');
      current.searchParams.forEach((v,k)=>{if(!['q','type','options[prefix]',...keys.map(key=>f[key])].includes(k))next.searchParams.set(k,v);});
      location.replace(next.toString());return;
    }
  }
  const init=(root=document)=>root.querySelectorAll('[data-tyre-search-form]').forEach(initForm);
  init();document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('gommadot:content-updated',()=>init());
})();
